export default "__VITE_PUBLIC_ASSET__dc345e5d__"